import { Button } from 'antd';
import type { SizeType } from 'antd/lib/config-provider/SizeContext';
import React, { Fragment, ReactElement, SyntheticEvent, useMemo } from 'react';

export enum ButtonSizes {
  small = 'small',
  medium = 'medium',
  large = 'large',
}

interface IConfirmButtons {
  cancelText?: string;
  className?: string;
  confirmText?: string;
  disabled?: boolean;
  margin?: string;
  noWrapper?: boolean;
  onCancel: (e: SyntheticEvent) => void;
  onConfirm: () => void;
  size?: SizeType;
}

const ConfirmButtons = ({
  cancelText = 'Cancel',
  className = '',
  confirmText = 'OK',
  disabled = false,
  margin = '10px 0 0',
  noWrapper = false,
  onCancel,
  onConfirm,
  size = 'middle',
}: IConfirmButtons): ReactElement => {
  const saveBtn = useMemo(
    () => (
      <Button
        className={className}
        type="primary"
        data-test-id="confirm-buttons-confirm"
        disabled={disabled}
        onClick={onConfirm}
        size={size}
        style={{ minWidth: '100px' }}
      >
        {confirmText}
      </Button>
    ),
    [className, disabled, onConfirm, confirmText, size],
  );

  const cancelButton = useMemo(
    () => (
      <Button
        className={className}
        data-test-id="confirm-buttons-cancel"
        onClick={onCancel}
        size={size}
        style={{ minWidth: '100px' }}
      >
        {cancelText}
      </Button>
    ),
    [className, onCancel, cancelText, size],
  );

  return noWrapper ? (
    <Fragment>
      {saveBtn}
      {cancelButton}
    </Fragment>
  ) : (
    <div style={{ margin: margin, display: 'flex', gap: '15px' }} data-test-id="confirm-buttons-wrapper">
      {saveBtn}
      {cancelButton}
    </div>
  );
};

export default ConfirmButtons;
